import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Globe } from 'lucide-react';

const LanguageToggle = () => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-2 px-4 py-2 bg-slate-800 hover:bg-slate-700 rounded-lg transition-colors text-white font-medium"
      aria-label="Toggle language"
    >
      <Globe className="w-4 h-4" />
      <span className="uppercase text-sm">{language === 'en' ? 'EN' : 'ES'}</span>
    </button>
  );
};

export default LanguageToggle;
